import { render, staticRenderFns } from "./PoliciesFooter.vue?vue&type=template&id=53e72f35"
import script from "./PoliciesFooter.vue?vue&type=script&lang=js"
export * from "./PoliciesFooter.vue?vue&type=script&lang=js"
import style0 from "./PoliciesFooter.vue?vue&type=style&index=0&id=53e72f35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports